module.exports = __webpack_public_path__ + "img/wechat-qr-code.51a66773.jpg";